/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AuthenticatedHomeScreen_query = {
    readonly viewer: {
        readonly firstName: string;
        readonly lastName: string;
        readonly " $fragmentRefs": FragmentRefs<"UserPrimaryPhoto_user">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"HomeScreenGuildsList_query" | "HomeScreenEventsList_query" | "HomeScreenPresentationsList_query">;
    readonly " $refType": "AuthenticatedHomeScreen_query";
};
export type AuthenticatedHomeScreen_query$data = AuthenticatedHomeScreen_query;
export type AuthenticatedHomeScreen_query$key = {
    readonly " $data"?: AuthenticatedHomeScreen_query$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AuthenticatedHomeScreen_query">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthenticatedHomeScreen_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UserPrimaryPhoto_user"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomeScreenGuildsList_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomeScreenEventsList_query"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HomeScreenPresentationsList_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
(node as any).hash = 'cf3177922f429931b89d2d82d935a1a5';
export default node;
